<div class="start-container d-flex flex-column align-items-center justify-content-space-between text-center p-20" (click)="continueButtonClicked()">
    <div class="social-proof d-flex justify-content-space-between w-100">
        <div class="d-flex flex-column gap-5 text-start">
            <span>Average Score</span>
            <span class="review-stars">●●●●◐</span>
            <i class="fa-solid fa-star-half"></i>
        </div>
        <div class="d-flex flex-column gap-5 text-end">
            <span>Based On</span>
            <div class="harvard-image"></div>
        </div>
    </div>
    <div class="content d-flex flex-column align-items-center justify-content-center w-100">
        <h1>Spark Your Arousal With Personalized Erotic Audio</h1>
        <div class="subtitle">Find exactly what you want, with whom you want and when you want. Explore your sexual desires</div>
        <div class="sticky-container p-15 mt-5 w-100">
            <button mat-flat-button color="tagus" class="pulsing" (click)="continueButtonClicked()">Get Started</button>
        </div>
        <div class="info gray-color">Made by Women for Women with ❤️ FemSecret LLC, 2025</div>
    </div>
</div>
